import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-permission-denied-dialog',
  template: `
    <div class="permission-denied-dialog">
      <div class="icon-wrapper">
        <div class="pulse"></div>
        <div class="circle">
          <img src="./../../../../assets/images/error.svg">
        </div>
      </div>

      <h2 class="title">{{ 'permission-denied.title' | translate }}</h2>
      <div class="message">{{ 'permission-denied.message' | translate }}</div>

      <div class="actions">
        <button (click)="close()">{{ 'permission-denied.ok' | translate }}</button>
      </div>
    </div>
  `,
  styles: [
    `
      .permission-denied-dialog { text-align: center; padding: 40px 30px 20px 30px;}
      .icon-wrapper { position: relative; width: 60px; height: 60px; margin: 0 auto 30px; }
      .circle { width: 60px; height: 60px; border-radius: 50%;  color: #fff; display: flex; align-items: center; justify-content: center; box-shadow: 0 8px 16px rgba(239,68,68,0.28); img {transform: scale(.9);} }
      .x { font-size: 34px; font-weight: 700; line-height: 1; transform: translateY(-1px); }
      .pulse { position: absolute; top: 50%; left: 50%; width: 60px; height: 60px; border-radius: 50%; border: 3px solid rgba(239,68,68,0.5); box-shadow: 0 0 0 8px rgba(239,68,68,0.12); transform: translate(-50%, -50%); animation: pulse 1.6s ease-out infinite; }
      @keyframes pulse { 0% { transform: translate(-50%, -50%) scale(1); opacity: 0.9; } 60% { transform: translate(-50%, -50%) scale(1.6); opacity: 0.15; } 100% { transform: translate(-50%, -50%) scale(1.6); opacity: 0; } }
      .title { margin: 8px 0 6px; font-size: 20px; font-family: Lato; font-style: normal; font-weight: 700;}
      .message { color: #444; margin-bottom: 14px; font-family: Lato; font-style: normal; font-weight: 400;}
      .actions { text-align: center; }
      .actions button {width:100%; background-color: #0074ec; border: none; border-radius: 8px; padding:7px; cursor: pointer; font-family: Lato; font-size: 16px; font-style: normal; font-weight: 600; line-height: 24px; color: #fff; }
    `
  ]
})
export class PermissionDeniedDialogComponent {
  constructor(private ref: MatDialogRef<PermissionDeniedDialogComponent>) {}
  close(): void { this.ref.close(); }
}


